import React, { Fragment } from 'react';

const ContentComponent = ({ children }) => {
    return <Fragment>{children}</Fragment>;
};

export default ContentComponent;
